import {useState} from 'react';

import {usdFormatter} from '@/lib/helpers';
import {SupabaseInstance} from '@/lib/utils';

import {useNotifications} from '@/providers/components/notificationsProvider';

function FundCard() {
  // Hooks
  const {toast} = useNotifications();

  // State
  const [amount, setAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handlePurchase = async () => {
    setIsLoading(true);
    if (amount > 10000) {
      setIsLoading(false);
      toast.error('Amount must be less than 10,000');
      return;
    }
    try {
      const {data, error} = await SupabaseInstance.supabase.functions.invoke('stripe-checkout-session', {
        body: {amount},
      });

      if (error) {
        console.error('Error creating Stripe checkout session', error);
        toast.error('Failed to create checkout session');
      } else {
        if (data.url) {
          window.location.href = data.url;
        }
      }
    } catch (error) {
      console.error('Error creating Stripe checkout session', error);
      toast.error('Failed to create checkout session');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="box custom-box">
      <div className="box-header">
        <div className="box-title">Fund Account</div>
      </div>
      <div className="box-body">
        <div className="tab-pane border-0 !p-0" id="fund-account" role="tabpanel" aria-labelledby="fund-account">
          <div className="mb-4">
            <span className="block font-semibold">Amount :</span>
            <div className="flex items-center justify-between text-[#8c9097] dark:text-white/50">
              <div>All Amounts In USD</div>
              <div>$10,000 limit</div>
            </div>
          </div>
          <div className="input-group crypto-buy-sell mb-4 block !flex-nowrap sm:flex">
            <input
              type="text"
              className="form-control crypto-buy-sell-input"
              aria-label="crypto buy select"
              placeholder="Enter Amount"
              value={amount}
              min={0}
              max={10000}
              onChange={e => setAmount(Number(e.target.value))}
            />
          </div>
          <div className="space-y-2">
            <div className="text-[.875rem]">
              <span className="font-semibold text-dark">Amount:</span>
              <span className="ms-2 text-[.875rem] text-[#8c9097] dark:text-white/50">
                {usdFormatter.format(amount)}
              </span>
              <span className="font-semibold text-dark ltr:float-right rtl:float-left">USD</span>
            </div>
            <div>
              <span className="font-semibold text-dark">TNC fee (2%):</span>
              <span className="ms-2 text-[.875rem] text-[#8c9097] dark:text-white/50">
                {usdFormatter.format(amount * 0.02)}
              </span>
              <span className="font-semibold text-dark ltr:float-right rtl:float-left">USD</span>
            </div>
            <div>
              <span className="font-semibold text-dark">Total:</span>
              <span className="ms-2 text-[.875rem] text-[#8c9097] dark:text-white/50">
                {usdFormatter.format(amount + amount * 0.02)}
              </span>
              <span className="font-semibold text-dark ltr:float-right rtl:float-left">USD</span>
            </div>
          </div>
          <div className="mt-6 grid">
            <button
              onClick={handlePurchase}
              disabled={amount <= 0 || isLoading}
              type="button"
              className="ti-btn ti-btn-info-full btn-wave ti-btn-lg dark:border-defaultborder/10"
            >
              {isLoading ? (
                <span className="flex items-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i>
                  Processing...
                </span>
              ) : (
                'Purchase'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FundCard;
